export default {"src":"/_next/static/media/calculator.00896922.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};